class ZirantiSlider {
	constructor() {
		this.variables();
		this.bindEvents();
		this.startSlick();
	}

	variables(){
		this.slickContainer = $('.jury-members .content .content-wrap');
		this.slickContainerImg = this.slickContainer.find('.left-content .images');
		this.slickContainerText = this.slickContainer.find('.right-content .slick-text');
	}

	bindEvents() {
	}

	startSlick() {

		$('#bottom-header-wrap').show();

		//Slick image
		this.slickContainerImg.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: false,
			asNavFor: '.jury-members .content .content-wrap .right-content .slick-text',
		});

		//Slick text
		this.slickContainerText.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: false,
			adaptiveHeight: true,
			infinite: true,
			asNavFor: '.jury-members .content .content-wrap .left-content .images',
		});

	}

}